export const VERTICAL_NAV_GROUP = 'VERTICAL_NAV_GROUP';
export const CUSTOM_OBJECT_PREFIX = 'customObject';
export const EXPANDABLE_NAV_GROUP = 'EXPANDABLE_NAV_GROUP';
export const EXPANDABLE_NAV_GROUP_MAX_INITIAL_DISPLAY_ITEMS = 5;
export const PRIMARY_NAV_ITEM_MIN_HEIGHT = '52px';
export const TRANSITION_TIME_NUMBER = 80;
export const TRANSITION_TIME = `${TRANSITION_TIME_NUMBER}ms`;
export let PinButtonActions;
(function (PinButtonActions) {
  PinButtonActions["collapse"] = "collapsed vertical nav";
  PinButtonActions["expand"] = "expanded vertical nav";
})(PinButtonActions || (PinButtonActions = {}));
export const VERTICAL_NAV_LIST_ITEM_MARGIN_NUMBER = 12;
export const VERTICAL_NAV_LIST_ITEM_MARGIN = `${VERTICAL_NAV_LIST_ITEM_MARGIN_NUMBER}px`;
export const BREEZE_AI_VERTICAL_NAV_ITEM_ID = 'breeze-ai';
export const ICON_ONLY_NAV_DELAY_MS = 100;
export let ScrollAbility;
(function (ScrollAbility) {
  ScrollAbility["up"] = "UP";
  ScrollAbility["down"] = "DOWN";
  ScrollAbility["all"] = "ALL";
})(ScrollAbility || (ScrollAbility = {}));
export const TOOLTIP_HEIGHT = 40;
export const PIN_BUTTON_ITEM_ID = 'PIN_BUTTON';